module.exports = __webpack_public_path__ + "static/media/antiagingflashampoules.4a8c55ac.png";